export var VERSION = '2.20.1';
//# sourceMappingURL=version.js.map